import { type MicrosoftMarketplaceSubscription } from '@youkeeps/shared';

import { baseRequest } from './helpers';

export const resolveSubscription = (data: { msalToken: string; marketplaceToken: string }) =>
  baseRequest<{ subscription: MicrosoftMarketplaceSubscription }>({
    requestType: 'post',
    url: `${import.meta.env['REACT_APP_FUNC_ENDPOINT']}/api/mampPostResolveSubscription`,
    body: { marketplaceToken: data.marketplaceToken },
    headers: { 'x-msal-token': data.msalToken },
  });

export const activateSubscription = (data: { msalToken: string; subscriptionId: string }) =>
  baseRequest<{ subscription: MicrosoftMarketplaceSubscription }>({
    requestType: 'post',
    url: `${import.meta.env['REACT_APP_FUNC_ENDPOINT']}/api/mampPostActivateSubscription`,
    body: { subscriptionId: data.subscriptionId },
    headers: { 'x-msal-token': data.msalToken },
  });

export const getAllSubscriptions = (msalToken: string) =>
  baseRequest<{ subscriptions: MicrosoftMarketplaceSubscription[] }>({
    requestType: 'get',
    url: `${import.meta.env['REACT_APP_FUNC_ENDPOINT']}/api/mampGetAllSubscriptions`,
    headers: { 'x-msal-token': msalToken },
  });

export const getSubscriptionById = (data: { msalToken: string; subscriptionId: string }) =>
  baseRequest<{ subscription: MicrosoftMarketplaceSubscription }>({
    requestType: 'get',
    url: `${import.meta.env['REACT_APP_FUNC_ENDPOINT']}/api/mampGetSubscriptionById`,
    headers: { 'x-msal-token': data.msalToken },
    queryParams: { subscriptionId: data.subscriptionId },
  });
